export default __webpack_public_path__ + "static/media/q26_step5.33dd1c08.png";